export const TENX_BRAND_PHRASE = "Sent and Powered by TenX";
export const TENX_BRAND_URL = process.env.REACT_APP_TENX_BRAND_URL;
if (!TENX_BRAND_URL || !/^https:\/\/[^/?#]+\/?$/.test(TENX_BRAND_URL)) {
  throw new Error("REACT_APP_TENX_BRAND_URL must be an explicit HTTPS website URL");
}